// extracted by mini-css-extract-plugin
module.exports = {"darkGreyColour":"#3A3A3A","midGreyColour":"#868686","primaryColour":"#09CCC4","container":"HeadingBlock-module--container--3h4f2"};